/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMatchId } from '../selectors/oddsHistory';
import { getDateTime } from '../utils/common';
import SVGComponent from './SVG/SVGComponent';
import {
  SVG_ICONS,
  MENU_ITEMS,
} from '../constants';
import { getSelectedMenuItem, getTimezone } from '../selectors/common';
import { getEventDetails, getTennisEventDetails } from '../selectors/matchTimeline';
import { getRoundSpecialDetails } from '../selectors/roundSpecials';

const mapToProps = (state) => ({
  getEventDetails: getEventDetails(state),
  getTennisEventDetails: getTennisEventDetails(state),
  matchId: getMatchId(state),
  selectedMenuItem: getSelectedMenuItem(state),
  getTimezone: getTimezone(state),
  roundSpecialDetails: getRoundSpecialDetails(state),
});

// eslint-disable-next-line no-unused-vars
const actionsToProps = (dispatch) => ({

});

const Section = (props) => {
  const navigate = useNavigate();

  const getDate = () => {
    if (props.getEventDetails) {
      return (
        <div className="content__wrapper-title-date">
          Start date:
          {' '}
          {getDateTime(props.getEventDetails.startDate, props.getTimezone)}
        </div>
      );
    }

    if (props.roundSpecialDetails) {
      return (
        <div className="content__wrapper-title-date">
          Start date:
          {' '}
          {getDateTime(props.roundSpecialDetails.startDateTime, props.getTimezone)}
        </div>
      );
    }

    if (props.getTennisEventDetails) {
      return (
        <div className="content__wrapper-title-date">
          Start date:
          {' '}
          {getDateTime(props.getTennisEventDetails.startDate, props.getTimezone)}
        </div>
      );
    }
    return null;
  };

  const showDate = () => {
    let showDateV = false;
    const pathsToCheck = [
      MENU_ITEMS.EVENTS.ODDS_HISTORY_STEP_1.path,
      MENU_ITEMS.EVENTS.ODDS_HISTORY_STEP_2.path,
      MENU_ITEMS.EVENTS.MATCH_TIMELINE.path,
      MENU_ITEMS.SOCCER.ROUND_SPECIALS_MATCH_TIMELINE.path,
      MENU_ITEMS.SOCCER.ROUND_SPECIALS_ODDS_HISTORY.STEP_1.path,
      MENU_ITEMS.SOCCER.ROUND_SPECIALS_ODDS_HISTORY.STEP_2.path,
      MENU_ITEMS.TENNIS_EVENTS.TENNIS_MATCH_TIMELINE.path,
      MENU_ITEMS.TENNIS_EVENTS.TENNIS_ODDS_HISTORY_STEP_1.path,
      MENU_ITEMS.TENNIS_EVENTS.TENNIS_ODDS_HISTORY_STEP_2.path,
    ];

    showDateV = pathsToCheck.some((path) => props.selectedMenuItem.includes(path));
    return showDateV;
  };

  if (showDate()) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between m-b-10">
          <div className="content__wrapper-title">
            <span id="backBtn_Section" onClick={() => navigate(-1)}>
              <SVGComponent
                className="content__wrapper-title-icon icon-xs m-r-10"
                src={`${SVG_ICONS.utility}#back-arrow`}
              />
            </span>
            {props.heading}
          </div>
          {getDate()}
        </div>
        <hr className="spacer-line" />

        {props.children}
      </>
    );
  }
  return (
    <>
      <div
        className="content__wrapper-title m-b-10"
        id={props.id}
      >
        {props.heading}
      </div>
      <hr className="spacer-line" />
      {props.children}
    </>
  );
};

export default connect(mapToProps, actionsToProps)(Section);
